import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AcademicYearService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getAcademicYears() {
    return this.http.get(
      `${this.baseUrl}/v1/academic-years`
    );
  }

  createAcademicYear(payload: {
    name: string;
    startDate: string;
    endDate: string;
    setAsCurrent: boolean;
  }) {
    return this.http.post(
      `${this.baseUrl}/v1/academic-years`,
      payload
    );
  }

  setCurrentAcademicYear(academicYearId: number) {
    return this.http.put(
      `${this.baseUrl}/v1/academic-years/${academicYearId}/current`,
      {}
    );
  }
}